import useSWR from "swr";

import { getProductStock, listProductStocks, PRODUCT_STOCKS_KEY } from "@/features/product-stocks/api/productStocksApi";
import { toErrorMessage } from "@/lib/swr";
import type { ProductStockDto } from "@/types/stock.types";

const EMPTY: ProductStockDto[] = [];

export function useProductStocks() {
  const { data, error, isLoading, mutate } = useSWR(PRODUCT_STOCKS_KEY, listProductStocks);

  return {
    stocks: data ?? EMPTY,
    isLoading,
    error: toErrorMessage(error),
    refresh: mutate,
  };
}

export function useProductStock(id: string | undefined) {
  const { data, error, isLoading, mutate } = useSWR(id ? `product-stocks/${id}` : null, () => getProductStock(id!));

  return {
    stock: data,
    isLoading,
    error: toErrorMessage(error),
    refresh: mutate,
  };
}
